export default __webpack_public_path__ + "static/media/cyber_thum02.55c0583e.jpg";